import React, { useMemo } from "react";
import { GraphQlSelect } from "./GraphQlSelect";
import { GraphQlSelectId } from "./GraphQlSelectId";
import { useClientSubTypeQueryQuery } from "../../generated/graphql";

export const ClientSubTypeSelect = (props) => {
  const isBhp = props.salesTeamPrefix === "BHP";

  const query = useClientSubTypeQueryQuery();

  const filteredQueryResult = useMemo(() => {
    const paginator = query.data?.clientSubTypes;
    const items = paginator?.data ?? [];

    const filtered = isBhp
      ? items.filter((x) => x?.sales_team_prefix === "BHP")
      : items.filter((x) => x?.sales_team_prefix !== "BHP");

    return {
      ...query,
      data: query.data
        ? {
          ...query.data,
          clientSubTypes: paginator
            ? { ...paginator, data: filtered }
            : { data: filtered },
        }
        : query.data,
    };
  }, [isBhp, query.data, query.loading, query.error]);

  return props.valueIsId
    ? <GraphQlSelectId queryResult={filteredQueryResult} {...props} labelField="name" />
    : <GraphQlSelect queryResult={filteredQueryResult} {...props} labelField="name" />;
};
